//中文
export default {
  urlBase: "",
  basePrev: "",
  baseSuffix: "",
  tarnsUrl: "/en",
  lang: "chinese",
  reversalLang: "english",
  stylePrev: "",
  ubsSuffox: "",
  index: {
    loginCookie: "islogin",
    userIdCookie: "pWebUserId",
    userNameCookie: "pWebUsername",
    welcome: "欢迎",
    login: "登录",
    signUp: "注册",
    setting: "设置",
    news: "最新发布",
    Logout: "退出",
    browseTopics: "专题统计报表",
    monthly: "月度",
    quarterly: "季度",
    annual: "年度",
    dataMap: "数据地图",
    visualization: "可视化产品",
    releaseSchedule: "发布日程",
    today: "今日发布",
    noreleasetoday: "今日无发布日程",
    tomorrow: "明日发布",
    noreleasetomorrow: "明日无发布日程",
    censuData: "普查资料",
    jjpc: "经普",
    rkpc: "人普",
    nypc: "农普",
    macroeconomic: "宏观经济运行情况",
    gnsczz: "国内生产总值（现价）",
    jmxfjgzs: "居民消费价格指数",
    gysczccjgzs: "工业生产者出厂价格指数",
    lscl: "粮食产量",
    gyzjzzs: "工业增加值增速",
    shxfplsze: "社会消费品零售总额",
    gdzctzzs: "固定资产投资增速",
    hotTopics: "热点问题解读",
    unit: "计量单位",
    yiyuan: "亿元",
    wandun: "万吨",
    percent: "%",
    snty100: "上年同月=100",
    ljz: "累计值",
    ljtbzj: "累计同比增减",
    bq: "本期",
    bqlj: "本期累计",
    langsChange: "English",
  },
  home: {
    urlkey: "url_zh",
  },
  register: {
    country: "中国",
  },
  nav: {
    home: "首页",
    monthly: "月度数据",
    quarterly: "季度数据",
    annual: "年度数据",
    visualization: "可视化产品",
    publications: "出版物",
    favorites: "我的收藏",
    help: "帮助",
    departmentData: "部门数据",
    regional: "地区数据",
    fsMonthData: "分省月度数据",
    fsQuarterData: "分省季度数据",
    fsYearData: "分省年度数据",
    mainMonthData: "主要城市月度价格",
    mainYearData: "主要城市年度数据",
    generalSurveyData: "普查数据",
    gatMonthData: "港澳台月度数据",
    gatYearData: "港澳台年度数据",
    taiwanYearData: "台湾省年度数据",
    macaoYearData: "澳门特别行政区年度数据",
    hongKongYearData: "香港特别行政区年度数据",
    internationalData: "国际数据",
    countryMonthData: "主要国家(地区)月度数据",
    sdjjtMonthData: "三大经济体月度数据",
    gjscMonthPrice: "国际市场月度商品价格",
    countryYearData: "主要国家年度数据",
    internationOrgWeb: "国际组织网站",
    countryStatisWeb: "各国统计网站",
    inOutTable: "投入产出表",
    fundFlowTable: "资金流量表",
    browseTopics: "专题统计报表",
  },
  dataPage: {
    downNumMessage: "超过最大下载数据量，请重新选择数据并下载！",
    browseTopics: "专题统计",
    simpleSearch: "简单查询",
    advancedSearch: "高级查询",
    addToFavorite: "添加收藏",
    tips: "注",
    newIndicator: "新增指标",
    jjtb: "经济图表",
    filter: "筛选",
    statistics: "统计",
    qckhkl: "去除空行空列",
    hlhh: "转置",
    indicatorsTips: "指标解释",
    newIndicatorDesc: "说明：指标只能从上表中选择！",
    noNewIndicator: "新增指标名称不能为空",
    noSelectNewIndicator: "已选指标不能为空",
    formulaError: "表达式不正确",
    duplicateName: "指标名称不能重复",
    selectedIndicator: "请选择指标",
    regionLabel: "地区",
    timeLabel: "数据时间",
    regionalLabel: "分地区序列",
    timeLabel2: "时间序列",
    xulie: "序列",
    year: "年",
    nationalTotal: "全国",
    hanglie: "行列相同",
    nokong: "输入不能为空",
    noData: "对不起，未能找到符合查询条件的信息。",
  },
  tree: {
    indicators: "指标",
  },
  report: {
    title: "快速查询",
    report: "报表",
    monthly: "月度",
    quarterly: "季度",
    annual: "年度",
    hongKongYearData: "香港特别行政区年度数据",
    macaoYearData: "澳门特别行政区年度数据",
    taiwanYearData: "台湾省年度数据",
  },
  sidebar: {
    jrtt: "今日头条",
    jrtt1: "头条号",
    jrttSub: "国家统计局",
    weibo: "官方微博",
    weibo1: "微博",
    weiboSub: "@中国统计",
    weChat: "官方微信",
    weChat1: "微信公众号",
    weChatSub: "统计微讯",
    gjtjj: "国家统计局",
    gjtjj1: "数据中国",
    gjtjjSub: "安卓客户端",
    dy: "抖音",
    dy1: "抖音号",
    dySub: "统计微讯",
    dataChina: "数据中国",
    help: "帮助",
    toTop: "返回顶部",
  },
  pageFooter: {
    // copyright: "版权所有：中华人民共和国国家统计局	党政机关",
    copyright: "版权所有：国家统计局",
    phoneNumber: "咨询电话：010-68576320",
    time: "周一至周五(上午8:30-11:30,下午1:30-4:30)",
    address: "地址：北京市西城区月坛南街57号（100826）",
    webCode: "网站标识码 bm36000002",
  },
  news: {
    prevText: "上一页",
    nextText: "下一页",
  },
  superSearch: {
    selectAll: "全选",
    Invert: "反选",
    clearAll: "清空",
    deleteAll: "全部删除",
    deleteUnselectedItems: "删除未选项",
    query: "查询数据",
    Article: "共",
    Items: "条",
    ResultsScreening: "结果中筛选",
    query2: "查询",
  },
  favorites: {
    pageTitle: "我的收藏",
    placeholder: "请输入内容",
    newFavorites: "新建收藏夹",
    name: "名  称",
    sourceDatabase: "所属库",
    createdDate: "创建时间",
    operation: "操作",
    placeholder1: "请输入名称",
    placeholder2: "请输入序号",
    orderNum: "序  号",
    newFavoritesTitle: "新建收藏夹",
    deletion: "是否确认删除此收藏?",
    tips: "提示",
    blankName: "新增文件夹名称不能为空！",
    blankOrder: "请填写序号",
    isNumber: "序号请输入纯数字",
    saveSuccess: "新建成功",
    loginFirst: "当前未登录或登录失效，请先登录",
    login: "前去登录",
    savePath: "保存路径",
    collectionSuccessful: "收藏成功",
    addFavoritesFirst: "请先添加收藏夹",
  },
  targetSelect: {
    indicators: "指标",
    noIndicator: "暂无指标",
  },
  timeSelectByPeriod: {
    eg: "例：输入格式如下",
    mo: "月",
    qr: "季",
    yr: "年",
    ot: "其他",
    time: "时间",
    submit: "确定",
  },
  timeSelect: {
    monthFormat: "yyyy年M月",
    yearFormat: "yyyy年",
    mPlaceholder: "请选择月份",
    yPlaceholder: "请选择年份",
    qPlaceholder: "请选择季度",
  },
  timeQuqrterPicker: {
    label: "时间",
    placeholder: "请选择季度",
  },
  stat_base: {
    sum: "合计",
    sum1: "求和",
    mean: "均值",
    max: "最大值",
    min: "最小值",
    median: "中位数",
    mode: "众数",
    variance: "方差",
    standardDeviation: "均方差",
  },
  editMenu: {
    titleKey: "title",
  },
  economicOperation: {
    year: "年",
  },
  loadingText: "加载中",
  empty: "暂无数据",
  more: "更多",
  download: "下载",
  print: "打印",
  save: "保存",
  reset: "重置",
  dataManage: "数据管理",
  reportManage: "报表管理",
  recover: "恢复",
  dimensionConversion: "维度转换",
  saveDefault: "保存默认",
  restoreDefaults: "还原默认",
  cancel: "取 消",
  region: "地区",
  row: "行",
  col: "列",
  ok: "确 定",
  edit: "编辑",
  delete: "删除",
  go: "跳转",
  confirm: "确 认",
  submit: "提 交",
  saveSuccess: "保存成功",
  count: {
    greaterThan: "大于",
    smallerThan: "小于",
    greaterThanOrEqualTo: "大于等于",
    smallerThanOrEqualTo: "小于等于",
    value: "数值",
    enterFilter: "请输入过滤条件",
    selectFilter: "请选择要删除的筛选条件",
    emptyFilter: "请选择筛选条件",
  },
  map: {
    showStyle: "显示样式",
    colorChart: "色块图",
    bubbleChart: "气泡图",
    barChart: "柱状图",
    barlineChart: "柱线图",
    txChart: "条形图",
    pieChart: "饼图",
    color: "颜色",
    shape: "形状",
    clear: "清空",
    legend: "图例",
    fsMonth: "分省月度",
    fsQuarter: "分省季度",
    fsYear: " 分省年度",
    keyForFilter: "输入关键字进行过滤",
    vector: "矢量",
    shadow: "影像",
    DarkTheme: "都市黑夜",
    StandardTheme: "标准地图",
    WhiteTheme: "淡雅白",
    BlueTheme: "极夜蓝",
    EmptyTheme: "空底图",
  },
  weeks: {
    sun: "日",
    mon: "一",
    tue: "二",
    wed: "三",
    thu: "四",
    fri: "五",
    sat: "六",
  },
  quarter: {
    q1: "第一季度",
    q2: "第二季度",
    q3: "第三季度",
    q4: "第四季度",
  },
  placeholders: {
    chooseYear: "选择年",
    chooseMonth: "选择月",
    chooseQuarter: "选择季度",
    choose: "请选择",
    tips: "提示",
    confirmLogout: "确认退出？",
    cancel: "取消",
    confirm: "确认",
    logoutSuccess: "退出成功",
    chooseArea: "请选择",
  },
  daochu: {
    gjtjj: "国家统计局",
    database: "数据库",
    time: "时间",
    note: "注",
    source: "数据来源",
    area: "地区",
    gjsj: "国家数据",
    quanguo: "全国",
  },
  login: {
    welcome: "欢迎登录",
    email: "邮箱",
    emailPlaceholder: "请输入邮箱",
    emailError: "邮箱格式不正确",
    password: "密码",
    passwordPlaceholder: "请输入密码",
    verificationCode: "验证码",
    codePlaceholder: "请输入验证码",
    remember: "自动登录",
    login: "登录",
    loginSuccess: "登录成功",
    newUser: "注册新用户",
    forgetPassword: "忘记密码",
    editPassword: "修改密码",
    register: "注册",
    password2: "再次输入密码",
    password2Placeholder: "请再次输入密码",
    passwordQuestion: "密码保护问题",
    questionPlaceholder: "请选择密码保护问题",
    passwordAnswer: "密码保护答案",
    answerPlaceholder: "请输入密码保护答案",
    phone: "手机号码",
    phonePlaceholder: "请输入手机号码",
    nation: "国家",
    nationPlaceholder: "请输入国家",
    professional: "行业",
    professionalPlaceholder: "请输入行业",
    job: "职业",
    jobPlaceholder: "请输入职业",
    ydmzsm: "阅读免责声明",
    submit: "提 交",
    psdLess8: "密码不能少于8个字符！",
    psdWeak: "密码太弱，密码中必须包含字母、数字、特殊字符！",
    twoPsdNotMatch: "两次输入密码不一致!",
    phoneError: "手机号格式不正确!",
    registerSuccess: "注册成功",
    inputNewPsd: "输入新密码",
    oldPassword: "输入旧密码",
    newPsdPlaceholder: "请输入新密码",
    oldPsdPlaceholder: "请输入旧密码",
    inputNewPsd2: "再次输入新密码",
    newPsd2Placeholder: "请再次输入新密码",
    back: "返 回",
    editSuccess: "修改成功",
    setting: "设置",
    mzsm: "免责声明",
  },
  scheduleUrl: "http://www.stats.gov.cn/sj/fbrc/bnxxfb/",
  protocol: {
    title: "用户使用协议",
    main1: "欢迎阅读国家统计数据库用户使用协议。本协议详述您在使用国家统计数据库时所须遵守的条款和条件。",
    main2: "如果您正在使用或已注册为国家统计数据库用户，我们都将视同您已详细阅读并完全理解和同意接受本协议下的所有条款和条件。",
    copyright: "版权声明",
    c1: "1、本数据库呈现的任何内容，无论数据、图表、商标、设计、文字和任何其他信息，未经特殊说明，其版权均属国家统计局所有。",
    c2: '2、转载或引用本数据库内容必须是以新闻性或资料性公共免费信息为使用目的的合理、善意引用，转载或引用本数据库版权所有之内容须注明"来源：国家统计局"字样。',
    c3: "3、转载或引用本数据库内容不得进行如下活动：",
    c31: "（1）对本数据库内容原意进行曲解、修改；",
    c32: "（2）损害本网或他人利益；",
    c33: "（3）任何违法行为；",
    c34: "（4）任何可能破坏公共秩序的行为。",
    c4:
      "4、若第三方网站想以任何形式建立链接至本数据库，必须先取得国家统计局同意，国家统计局有权决定是否核准建立此链接。凡从第三方网站建立任何链接至本数据库，国家统计局不负责该链接的建立与设置。依此建立的链接，并不构成国家统计局与该第三方网站有任何形式的合作，亦不构成国家统计局对该第三方网站的认同。",
    c5: "5、对于违反国家有关法律法规，不尊重本数据库声明的行为，国家统计局保留采取法律措施，追究其责任的权力。",
    liability: "免责声明",
    l1: "1、您在使用本数据库出现下述相关情况时，国家统计局对此不承担责任：",
    l11: "（1）任何由数据引起的直接或间接的损失，包括利润、收入或投资损失；",
    l12: "（2）任何不可预见性因素导致的损失；",
    l13: "（3）非国家统计局或提供本服务的第三方所能合理控制的事件，包括互联网传输中断、延迟或数据错误，电讯、网络和电脑病毒，以及通讯设施故障引发的数据失真或不及时等。",
    l2: "2、本数据库引用、摘录或转载来自第三方的内容时，并不表明这些内容代表国家统计局的观点，其目的只是供访问者交流与参考。",
    privacy: "隐私保密说明",
    p1: "1、国家统计局可能会根据需要收集您的相关注册信息，以便了解您的需求，为您提供更优质的产品和服务。",
    p2: "2、国家统计局尊重并保护所有用户的个人隐私权，您注册的用户名、电子邮件地址等个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，本数据库不会泄露给第三方。",
    append: "附则",
    a1: "1、本协议未涉及的问题请参见国家有关法律法规，当本协议与国家法律法规冲突时，以国家法律法规为准。",
    a2: "2、对本协议的解释、修改及更新权均属于国家统计局所有。",
  },
  area: {
    110000000000: "北京市",
    120000000000: "天津市",
    130000000000: "河北省",
    140000000000: "山西省",
    150000000000: "内蒙古自治区",
    210000000000: "辽宁省",
    220000000000: "吉林省",
    230000000000: "黑龙江省",
    310000000000: "上海市",
    320000000000: "江苏省",
    330000000000: "浙江省",
    340000000000: "安徽省",
    350000000000: "福建省",
    360000000000: "江西省",
    370000000000: "山东省",
    410000000000: "河南省",
    420000000000: "湖北省",
    430000000000: "湖南省",
    440000000000: "广东省",
    450000000000: "广西壮族自治区",
    460000000000: "海南省",
    500000000000: "重庆市",
    510000000000: "四川省",
    520000000000: "贵州省",
    530000000000: "云南省",
    540000000000: "西藏自治区",
    610000000000: "陕西省",
    620000000000: "甘肃省",
    630000000000: "青海省",
    640000000000: "宁夏回族自治区",
    650000000000: "新疆维吾尔族自治区",
    710000000000: "台湾省",
    810000000000: "香港特别行政区",
    820000000000: "澳门特别行政区",
  },
  date: {
    year: "{yyyy}年",
    month: "{yyyy}年{mm}月",
    quarter: "{yyyy}年第{ss}季度",
  },
  chartTable: {
    row: "行",
    column: "列",
    bt: "标题",
    remark1: "说明：如果所选的作图项过多，可能会影响图例的正常显示。",
    tuxing: "图形",
    zhu: "柱",
    xian: "线",
    isCzz: "是否次坐标",
    leiAdd: "累加",
    showDataLable: "显示数据标签",
  },
};
